import React, { useState } from 'react';
import logo from "../asset/logo.png"
import { RiContactsLine } from "react-icons/ri";
import { MdOutlineContactEmergency } from "react-icons/md";
import { IoClose } from "react-icons/io5"
import axios from 'axios'
import { apiBaseUrl } from '../utils';
import { isValidEmail } from "../utils/csvreader";

const Header = ({ handleSubscribe }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        axios.post(`${apiBaseUrl}/subscribe`, { email: email })
            .then(response => {
                if (response.status === 200) {
                    handleSubscribe();
                    // clear email
                    setEmail('')
                }
            })
            .catch(error => console.error(error));
    };

    return (
        <header className="bg-black shadow text-white w-full pb-0 fixed top-0 left-0 z-50" style={{ fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif" }}>
            <div className="max-w-[1340px] mx-auto w-full relative flex items-center justify-between px-6 py-3">
                <div className="flex-shrink-0">
                    <a href="/">
                        <img className='max-h-14 max-w-14' src={process.env.PUBLIC_URL + '/images/logo.png'} alt="Logo" />
                    </a>
                </div>
                <form onSubmit={handleSubmit} className='flex items-center gap-2'>
                    {error && <span className='text-red-400 text-sm mr-2'>{error}</span>}
                    <input
                        className="bg-[#111] text-white text-sm border border-[#333] px-4 py-2.5 rounded-full focus:border-[#1FE2A5] focus:outline-none transition-colors w-56"
                        type="text"
                        value={email}
                        onChange={(e) => { setError(''); setEmail(e.target.value); }}
                        placeholder="Your email"
                        required
                    />
                    <button
                        type='submit'
                        disabled={error}
                        className={`cursor-pointer px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${error ? 'cursor-not-allowed opacity-50' : 'hover:opacity-90'}`}
                        style={{
                            background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)",
                            color: "#000",
                            border: "none",
                            letterSpacing: "0.02em",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Subscribe to free Newsletter
                    </button>
                </form>
            </div>
            <div className="w-full h-px" style={{ background: "linear-gradient(90deg, transparent, #1FE2A5, transparent)" }} />
        </header>
    );
};

export default Header;
